import { render, staticRenderFns } from "./DeliveryPostOffice.vue?vue&type=template&id=d6edb376&lang=pug&"
import script from "./DeliveryPostOffice.vue?vue&type=script&lang=js&"
export * from "./DeliveryPostOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports